import { OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroy } from 'take-until-destroy';
import { LogManager } from '../../log/log.manager';
import { LogCat } from '../../log/log.categories';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@progress/kendo-angular-intl";
import * as i2 from "./intl.proxy";
import * as i3 from "../../../app-auth/services/patient.account.service";
import * as i4 from "../../../app-auth/services/auth-provider.service";
import * as i5 from "./rtl.service";
var IntlServicePP = /** @class */ (function () {
    function IntlServicePP(localeId, intlService, intlProxyPP, patientAccountService, authProviderService, rtlService) {
        this.localeId = localeId;
        this.intlService = intlService;
        this.intlProxyPP = intlProxyPP;
        this.patientAccountService = patientAccountService;
        this.authProviderService = authProviderService;
        this.rtlService = rtlService;
        this.usedLanguageSubject = new BehaviorSubject(null);
        this.getLanguages();
    }
    Object.defineProperty(IntlServicePP.prototype, "firstWeekDay", {
        /*
           * Returns the first week day index starting from Sunday (0 == Sunday).
           */
        get: function () {
            return this.intlService.firstDay();
        },
        enumerable: true,
        configurable: true
    });
    IntlServicePP.prototype.getDefaultLanguage = function (languages) {
        var language;
        var navigatorLanguage = (navigator.language || navigator.userLanguage).toLowerCase();
        language = languages.find(function (l) { return l.code.toLowerCase() === navigatorLanguage; });
        if (language) {
            this.defaultBrowserLanguage = language;
            return language;
        }
        // Get the browser language without location.
        language = languages.find(function (l) { return l.code.toLowerCase() === navigatorLanguage.split('-')[0]; });
        if (language) {
            this.defaultBrowserLanguage = language;
            return language;
        }
        // Get the defined default system language.
        language = languages.find(function (l) { return l.isDefault; });
        if (language) {
            LogManager.debug(LogCat.Intl.GetDefaultLanguage, 'The browser language is not supported. Setting to the configured default language.');
            this.defaultBrowserLanguage = language;
            return language;
        }
        // Get the defined English language.
        language = languages.find(function (l) { return l.languageKey === 1000; });
        if (language) {
            LogManager.error(LogCat.Intl.GetDefaultLanguage, 'The browser and configured default languages are not supported. Setting to pre-defined English.');
            this.defaultBrowserLanguage = language;
            return language;
        }
        // Get the first defined active language.
        LogManager.error(LogCat.Intl.GetDefaultLanguage, 'The browser, configured default and pre-defined English languages are not supported. Setting to first defined active language.');
        language = languages.filter(function (l) { return l.isActive; }).length ? languages.filter(function (l) { return l.isActive; })[0] : languages[0];
        this.defaultBrowserLanguage = language;
        return language;
    };
    IntlServicePP.prototype.ngOnDestroy = function () { };
    IntlServicePP.prototype.getLanguages = function () {
        var _this = this;
        this.intlProxyPP.getLanguages().pipe(takeUntilDestroy(this)).subscribe(function (res) {
            _this.cachedLanguages = res;
            if (_this.authProviderService.isAuthenticated()) {
                var langToSet = _this.cachedLanguages
                    .find(function (l) { return l.languageKey === _this.authProviderService.currentPatient.accountPreferences.defaultLanguageKey; });
                _this.setLanguage(langToSet ? langToSet : _this.getDefaultLanguage(res), false, true);
            }
            else {
                _this.setLanguage(_this.getDefaultLanguage(res), false, true);
            }
        });
    };
    IntlServicePP.prototype.getUsedLanguageObservable = function () {
        return this.usedLanguageSubject.asObservable().pipe(filter(function (x) { return x !== undefined && x !== null; }));
    };
    IntlServicePP.prototype.setLanguage = function (language, loginInProgress, fromManualSelection) {
        if (loginInProgress === void 0) { loginInProgress = false; }
        if (fromManualSelection === void 0) { fromManualSelection = false; }
        if (language.rightToLeft !== this.rtlService.isRtl()) {
            this.rtlService.setDir(language, loginInProgress);
        }
        this.setLocale(language.kendoCode);
        this.usedLanguageSubject.next(Object.assign(language, { manualSelect: fromManualSelection }));
        this.usedLanguage = language;
    };
    IntlServicePP.prototype.setLocale = function (locale) {
        this.localeId = locale;
        this.intlService.localeId = locale;
    };
    IntlServicePP.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IntlServicePP_Factory() { return new IntlServicePP(i0.ɵɵinject(i0.LOCALE_ID), i0.ɵɵinject(i1.IntlService), i0.ɵɵinject(i2.IntlProxyPP), i0.ɵɵinject(i3.PatientAccountService), i0.ɵɵinject(i4.AuthProviderService), i0.ɵɵinject(i5.RtlService)); }, token: IntlServicePP, providedIn: "root" });
    return IntlServicePP;
}());
export { IntlServicePP };
